// ICE servers for WebRTC peer connections
// Self-hosted coturn TURN server on Fly.io (disbound-turn)
// Dedicated IPv4: 149.248.215.21

const ICE_SERVERS = [
  // STUN
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
  { urls: "stun:149.248.215.21:3478" },
  // TURN (self-hosted coturn on Fly.io)
  {
    urls: "turn:149.248.215.21:3478",
    username: "disbound",
    credential: "disboundturn2026",
  },
  {
    urls: "turn:149.248.215.21:3478?transport=tcp",
    username: "disbound",
    credential: "disboundturn2026",
  },
];

export async function fetchIceServers() {
  return ICE_SERVERS;
}

export default ICE_SERVERS;
